
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","viewBox":"0 0 300 200"}, attrs),
              ...rest,
            },
            children.concat([_c('defs',[_c('g',{attrs:{"id":"c"}},[_c('clipPath',{attrs:{"id":"a"}},[_c('path',{attrs:{"d":"M-109 104a104 104 0 000-208h218a104 104 0 000 208z"}})]),_c('path',{attrs:{"id":"b","d":"M-55 74a55 55 0 01110 0V-74a55 55 0 01-110 0z","clip-path":"url(#a)"}}),_c('use',{attrs:{"xlink:href":"#b","transform":"rotate(90)"}})])]),_c('path',{attrs:{"fill":"#fff","d":"M0 0h300v200H0z"}}),_c('path',{attrs:{"d":"M130 0v80H0v40h130v80h40v-80h130V80H170V0h-40z","fill":"red"}}),_c('use',{attrs:{"xlink:href":"#c","transform":"translate(64.45 39.45)","fill":"red"}}),_c('use',{attrs:{"xlink:href":"#c","transform":"translate(235.55 160.55)","fill":"red"}}),_c('use',{attrs:{"xlink:href":"#c","transform":"translate(235.55 39.45)","fill":"red"}}),_c('use',{attrs:{"xlink:href":"#c","transform":"translate(64.45 160.55)","fill":"red"}})])
          )
        }
      }
    